'use client';

import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@repo/palette';
import { useScreenSize } from '@repo/utils';

import { ClaimButton } from './button';

interface NotFoundProps {
  imageUrl: string;
  title: string;
  description: string;
  description2?: string;
  buttonLabel: string;
  buttonRoute?: string;
  buttonOnClick?: () => void;
}

export const NotFound: React.FC<NotFoundProps> = ({
  imageUrl,
  title,
  description,
  description2,
  buttonLabel,
  buttonRoute,
  buttonOnClick,
}) => {
  const { isMobile } = useScreenSize();

  return (
    <div className='flex flex-col items-center gap-4 md:mt-14'>
      <Image
        src={imageUrl}
        alt='404'
        width={isMobile ? 400 : 600}
        height={isMobile ? 300 : 500}
      />
      <div
        className={cn(
          'flex max-w-sm flex-col items-center text-center text-white md:max-w-md',
          '-mt-6 md:-mt-14',
        )}
      >
        <h2 className='font-fredoka mb-4 text-5xl font-bold md:text-[64px]'>
          {title}
        </h2>
        <p className='font-kumbh mb-4 text-sm font-semibold md:w-3/4 md:text-base'>
          {description}
        </p>
        <p className='font-kumbh mb-7 text-sm font-light text-white/50 md:text-base'>
          {description2}
        </p>

        {buttonRoute ? (
          <Link
            href={buttonRoute}
            className='w-[300px]'
          >
            <ClaimButton
              text={buttonLabel}
              hasEnoughSol={true}
              hasSolWallet={true}
            />
          </Link>
        ) : (
          <div className='w-[300px]'>
            <ClaimButton
              text={buttonLabel}
              hasEnoughSol={true}
              hasSolWallet={true}
              onClick={buttonOnClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};
